import { t } from 'i18next';
import { API_URL } from '../config/connect';

export const submitSmsCode = async (smsCode, taskId) => {
    try {
        const response = await fetch(`${API_URL}/api/v1/auth/mfa/${taskId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ sms_code: smsCode }),
        });

        const data = await response.json();
        
        if (!response.ok) {
            // Согласно документации, ошибки могут быть в формате:
            // { detail: { success: false, error_code: "...", message: "..." } }
            // или { detail: { message: "..." } }
            // или { detail: "..." }
            const errorMessage = data?.detail?.message || 
                                (typeof data?.detail === 'string' ? data.detail : null) ||
                                data?.message || 
                                t('error_sms_code');
            throw new Error(errorMessage);
        }

        // Согласно документации, успешный ответ: { task_id: "..." }
        return data.task_id;
    } catch (error) {
        console.error('Ошибка верификации SMS-кода:', error.message);
        throw error;
    }
};

export const loginWithTaskId = async (task_id_from_response, typeAuth) => {
    try {
        const response = await fetch(`${API_URL}/api/v1/auth/${typeAuth}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'task_id': task_id_from_response,
            },
            body: JSON.stringify({}),
        });

        const data = await response.json();
        
        if (!response.ok) {
            // Согласно документации, ошибки могут быть в формате:
            // { detail: { message: "...", links: [...] } }
            // или { detail: { message: "..." } }
            const errorMessage = data?.detail?.message || 
                                (typeof data?.detail === 'string' ? data.detail : null) ||
                                data?.message || 
                                'Ошибка при выполнении запроса';
            throw new Error(errorMessage);
        }

        // Для signup: согласно документации возвращается { message: "...", task_id: "..." }
        // После успешного signup нужно сделать login для получения токенов
        if (typeAuth === 'signup') {
            // Используем task_id из ответа signup, если он есть, иначе используем переданный task_id
            const taskIdForLogin = data.task_id || task_id_from_response;
            
            // После регистрации делаем login с task_id
            const loginResponse = await fetch(`${API_URL}/api/v1/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'task_id': taskIdForLogin,
                },
                body: JSON.stringify({}),
            });

            const loginData = await loginResponse.json();
            
            if (!loginResponse.ok) {
                const errorMessage = loginData?.detail?.message || 
                                    (typeof loginData?.detail === 'string' ? loginData.detail : null) ||
                                    loginData?.message || 
                                    'Ошибка при входе после регистрации';
                throw new Error(errorMessage);
            }

            // Для login возвращаются токены: { access_token, refresh_token, biometric_token, token_type }
            return loginData;
        }

        // Для login возвращаются токены: { access_token, refresh_token, biometric_token, token_type }
        return data;
    } catch (error) {
        console.error('Ошибка завершения авторизации:', error.message);
        throw error;
    }
};

export const sendSms = async (taskId) => {
    try {
        const response = await fetch(
            `${API_URL}/api/v1/auth/mfa/${taskId}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );

        if (!response.ok) {
            const data = await response.json();
            // Согласно документации, ошибки могут быть в формате:
            // { detail: { message: "..." } }
            const errorMessage = data?.detail?.message || 
                                (typeof data?.detail === 'string' ? data.detail : null) ||
                                data?.message || 
                                'Ошибка при отправке SMS';
            throw new Error(errorMessage);
        }

        // Согласно документации, успешный ответ: {} (пустой объект)
        return {};
    } catch (err) {
        console.error('Ошибка отправки SMS:', err.message);
        throw err;
    }
};

export const sendEmailCode = async (taskId) => {
    try {
        const response = await fetch(
            `${API_URL}/api/v1/auth/mfa/${taskId}/email`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({})
            }
        );

        const data = await response.json();

        if (!response.ok) {
            // Согласно документации, ошибки могут быть в формате:
            // { detail: { message: "..." } }
            const errorMessage = data?.detail?.message || 
                                (typeof data?.detail === 'string' ? data.detail : null) ||
                                data?.message || 
                                t('errorEmailCode') || 'Ошибка при отправке кода на email';
            throw new Error(errorMessage);
        }

        // Согласно документации, успешный ответ: { message: "Verification code sent to email successfully" }
        return data;
    } catch (err) {
        console.error('Ошибка отправки кода на email:', err.message);
        throw err;
    }
};

export const sendWhatsAppCode = async (taskId) => {
    try {
        const response = await fetch(
            `${API_URL}/api/v1/auth/mfa/${taskId}/whatsapp`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );

        const data = await response.json();

        if (!response.ok) {
            // Согласно документации, ошибки могут быть в формате:
            // { detail: { message: "..." } }
            const errorMessage = data?.detail?.message || 
                                (typeof data?.detail === 'string' ? data.detail : null) ||
                                data?.message || 
                                'Ошибка при отправке кода через WhatsApp';
            throw new Error(errorMessage);
        }

        // Согласно документации, успешный ответ: { message: "...", phone_number: "..." }
        return data;
    } catch (err) {
        console.error('Ошибка отправки кода через WhatsApp:', err.message);
        throw err;
    }
};

export const saveTokens = (access_token, refresh_token, biometric_token) => {
    localStorage.setItem('access_token', access_token);
    localStorage.setItem('refresh_token', refresh_token);
    localStorage.setItem('biometric_token', biometric_token);
};